export default {
  exportLogin(st) {
    return st.login;
  },
  exportUserId(st) {
    return st.profile.id;
  },
  exportProfile(st) {
    return st.profile;
  },
  exportSnackBar(st) {
    return st.snackBar;
  },
  isAuthenticated(st) {
    return !!st.accessToken;
  },
  exportMessageBox(st) {
    return st.msgBox;
  },
  exportRwdType(st) {
    return st.rwdType;
  },
};
